import {ProductFileGroupInterface} from "../../interfaces/product/ProductFileInterface";

// файлы лежат на pride.ru, в API путь от корня сайта
const getFullUrl = (url: string) => url.startsWith('http') ? url : `https://www.pride.ru${url}`;

export const formatFileSize = (size: number): string => {
    if (size >= 1048576) {
        return (size / 1048576).toFixed(1).replace('.', ',') + ' МБ';
    }

    return Math.max(1, Math.round(size / 1024)) + ' КБ';
};

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

export const isImageFile = (ext: string): boolean => IMAGE_EXTS.includes(ext.toLowerCase());

const isReleaseGroup = (typeName: string): boolean => typeName.trim().toLowerCase() === 'релиз';

/**
 * Файлы товара из 1С по типам документов (Инструкция, Релиз, Паспорт, Деталировка, Ремонтный комплект...).
 * Превью — только у «Релиза», по клику onImageClick открывает полный размер (модалка в TechDoc).
 * «Скачать» ведёт на относительный путь из API: /upload/product-files/ отдаёт nginx b2b-домена
 * (alias на public сайта), поэтому файл скачивается по атрибуту download, а не открывается в браузере.
 */
export default function ProductFiles({groups, onImageClick}: {
    groups?: ProductFileGroupInterface[],
    onImageClick?: (url: string) => void
}) {
    if (!groups || groups.length === 0) {
        return null;
    }

    return (
        <div className="product-files mb-4">
            {groups.map(group => (
                <div className="product-files__group mb-3" key={group.type_id}>
                    <h5 className="product-files__type">{group.type_name}</h5>
                    <ul className="product-files__list list-unstyled mb-0">
                        {group.files.map((file, index) => {
                            const url = getFullUrl(file.url);
                            const name = group.type_name + (group.files.length > 1 ? ` ${index + 1}` : '');

                            return (
                                <li key={file.uid} className="mb-2">
                                    {isImageFile(file.ext) && isReleaseGroup(group.type_name) && (
                                        <a
                                            href={url}
                                            onClick={(e) => {
                                                if (onImageClick) {
                                                    e.preventDefault();
                                                    onImageClick(url);
                                                }
                                            }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="d-block"
                                            aria-label={`Увеличить: ${name}`}
                                            style={{cursor: 'zoom-in'}}
                                        >
                                            <img
                                                src={url}
                                                alt={name}
                                                loading="lazy"
                                                style={{maxWidth: '600px', width: '100%', height: 'auto', border: '1px solid silver'}}
                                            />
                                        </a>
                                    )}
                                    <a href={file.url} download={`${name}.${file.ext}`} className="t-orange">
                                        Скачать {name}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    );
}
